import React, { useState, useEffect, useRef } from "react";
import useFetch from "./useFetch.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/muuri_styles.css";
import "../styles/add_pane.css";
import "../styles/modal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faSearch,
  faChevronDown,
  faWifi,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import $ from "jquery";
import config from "../config.js";
import Cookie from "universal-cookie";
import PropTypes from "prop-types";
import axios from "axios";
import _ from "lodash";

// Custom Searchable Dropdown Component
const SearchableDropdown = ({
  options,
  value,
  onChange,
  placeholder,
  label,
  hasAlarms,
  onAlarmToggle,
  alarmEnabled,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  // Filter options based on search term
  const filteredOptions = options.filter(
    (option) =>
      option.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      option.type.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Get selected option display text
  const getSelectedText = () => {
    if (!value) return placeholder;
    const selected = options.find((opt) => opt.value === value);
    return selected ? selected.name : placeholder;
  };

  // Handle option selection
  const handleSelect = (option) => {
    onChange(option.value);
    setIsOpen(false);
    setSearchTerm("");
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}
    >
      <div style={{ flex: "0 0 100px", marginRight: "10px" }}>
        <label style={{ fontSize: "14px", color: "#333", fontWeight: "500" }}>
          {label}
        </label>
      </div>

      <div ref={dropdownRef} style={{ position: "relative", flex: "1" }}>
        <div
          onClick={() => setIsOpen(!isOpen)}
          style={{
            padding: "10px 12px",
            border: "2px solid #e1e5e9",
            borderRadius: "8px",
            backgroundColor: "#fff",
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "14px",
            transition: "all 0.2s ease",
            boxShadow: isOpen ? "0 0 0 3px rgba(0, 123, 255, 0.1)" : "none",
            borderColor: isOpen ? "#007bff" : "#e1e5e9",
            minHeight: "40px",
          }}
        >
          <span
            style={{
              color: value ? "#333" : "#6c757d",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {getSelectedText()}
          </span>
          <FontAwesomeIcon
            icon={faChevronDown}
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease",
              color: "#6c757d",
            }}
          />
        </div>

        {isOpen && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              right: 0,
              backgroundColor: "#fff",
              border: "2px solid #007bff",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              zIndex: 1000,
              maxHeight: "300px",
              overflow: "hidden",
            }}
          >
            {/* Search Input */}
            <div style={{ padding: "12px", borderBottom: "1px solid #e9ecef" }}>
              <div style={{ position: "relative" }}>
                <FontAwesomeIcon
                  icon={faSearch}
                  style={{
                    position: "absolute",
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#6c757d",
                    fontSize: "14px",
                  }}
                />
                <input
                  type="text"
                  placeholder="Search sources..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px 12px 8px 35px",
                    border: "1px solid #dee2e6",
                    borderRadius: "6px",
                    fontSize: "14px",
                    outline: "none",
                    transition: "border-color 0.2s ease",
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "#007bff")}
                  onBlur={(e) => (e.target.style.borderColor = "#dee2e6")}
                />
              </div>
            </div>

            {/* Options List */}
            <div style={{ maxHeight: "200px", overflowY: "auto" }}>
              {filteredOptions.length === 0 ? (
                <div
                  style={{
                    padding: "16px",
                    textAlign: "center",
                    color: "#6c757d",
                    fontSize: "14px",
                  }}
                >
                  No sources found
                </div>
              ) : (
                <>
                  {/* HTTP Sources */}
                  {filteredOptions.some((opt) => opt.type === "HTTP") && (
                    <>
                      <div
                        style={{
                          padding: "8px 12px",
                          backgroundColor: "#f8f9fa",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#495057",
                          borderBottom: "1px solid #e9ecef",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faGlobe}
                          style={{ marginRight: "6px", color: "#28a745" }}
                        />
                        HTTP SOURCES
                      </div>
                      {filteredOptions
                        .filter((opt) => opt.type === "HTTP")
                        .map((option, idx) => (
                          <div
                            key={`http-${idx}`}
                            onClick={() => handleSelect(option)}
                            style={{
                              padding: "12px",
                              cursor: "pointer",
                              backgroundColor:
                                value === option.value
                                  ? "#e3f2fd"
                                  : "transparent",
                              borderLeft:
                                value === option.value
                                  ? "3px solid #007bff"
                                  : "3px solid transparent",
                              transition: "all 0.2s ease",
                              fontSize: "14px",
                            }}
                            onMouseEnter={(e) => {
                              if (value !== option.value) {
                                e.target.style.backgroundColor = "#f8f9fa";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (value !== option.value) {
                                e.target.style.backgroundColor = "transparent";
                              }
                            }}
                          >
                            <div style={{ fontWeight: "500", color: "#333" }}>
                              {option.name}
                            </div>
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#6c757d",
                                marginTop: "2px",
                              }}
                            >
                              {option.method} • {option.url}
                            </div>
                          </div>
                        ))}
                    </>
                  )}

                  {/* MQTT Sources */}
                  {filteredOptions.some((opt) => opt.type === "MQTT") && (
                    <>
                      <div
                        style={{
                          padding: "8px 12px",
                          backgroundColor: "#f8f9fa",
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#495057",
                          borderBottom: "1px solid #e9ecef",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faWifi}
                          style={{ marginRight: "6px", color: "#17a2b8" }}
                        />
                        MQTT SOURCES
                      </div>
                      {filteredOptions
                        .filter((opt) => opt.type === "MQTT")
                        .map((option, idx) => (
                          <div
                            key={`mqtt-${idx}`}
                            onClick={() => handleSelect(option)}
                            style={{
                              padding: "12px",
                              cursor: "pointer",
                              backgroundColor:
                                value === option.value
                                  ? "#e3f2fd"
                                  : "transparent",
                              borderLeft:
                                value === option.value
                                  ? "3px solid #007bff"
                                  : "3px solid transparent",
                              transition: "all 0.2s ease",
                              fontSize: "14px",
                            }}
                            onMouseEnter={(e) => {
                              if (value !== option.value) {
                                e.target.style.backgroundColor = "#f8f9fa";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (value !== option.value) {
                                e.target.style.backgroundColor = "transparent";
                              }
                            }}
                          >
                            <div style={{ fontWeight: "500", color: "#333" }}>
                              {option.name}
                            </div>
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#6c757d",
                                marginTop: "2px",
                              }}
                            >
                              {option.host}:{option.port} • {option.topic}
                            </div>
                          </div>
                        ))}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Alarm Toggle */}
      {hasAlarms && (
        <label
          style={{
            display: "flex",
            alignItems: "center",
            marginLeft: "15px",
            fontSize: "14px",
            color: "#333",
            cursor: "pointer",
            padding: "8px 12px",
            backgroundColor: "#f8f9fa",
            borderRadius: "6px",
            border: "1px solid #dee2e6",
            transition: "all 0.2s ease",
          }}
        >
          <input
            type="checkbox"
            checked={alarmEnabled}
            onChange={onAlarmToggle}
            style={{
              marginRight: "8px",
              width: "18px",
              height: "18px",
              borderRadius: "4px",
              border: "2px solid #007bff",
              accentColor: "#007bff",
              cursor: "pointer",
            }}
          />
          <span style={{ fontWeight: "500" }}>Alarms</span>
        </label>
      )}
    </div>
  );
};

const WidgetSettingModal = (props) => {
  const cookies = new Cookie();
  const userToken = cookies.get("userToken");
  const headers = { Authorization: `Bearer ${userToken}` };

  const {
    data: httpDatasources,
    error: httpError,
    isPending: isHttpPending,
  } = useFetch(
    {
      actionInitiatingUser: { userID: cookies.get("userID") },
      URL: config.BACKEND_URL + "/logger_sources/sources/http",
      timeout: 5000,
    },
    true
  );

  const {
    data: mqttDatasources,
    error: mqttError,
    isPending: isMqttPending,
  } = useFetch(
    {
      actionInitiatingUser: { userID: cookies.get("userID") },
      URL: config.BACKEND_URL + "/logger_sources/sources/mqtt",
      timeout: 5000,
    },
    true
  );

  const [selectedSources, setSelectedSources] = useState(
    props.widget?.datasource?.map((ds) =>
      ds.type === "HTTP"
        ? `${ds.id},${ds.key},${ds.name},${ds.type},${ds.URL},${ds.method}`
        : `${ds.id},${ds.name},${ds.type},${ds.host},${ds.port},${ds.topic},${ds.key}`
    ) || []
  );

  const [selectedSource, setSelectedSource] = useState(
    props.widget?.datasource?.[0]
      ? `${
          props.widget.datasource[0].type === "HTTP"
            ? `${props.widget.datasource[0].id},${props.widget.datasource[0].key},${props.widget.datasource[0].name},${props.widget.datasource[0].type},${props.widget.datasource[0].URL},${props.widget.datasource[0].method}`
            : `${props.widget.datasource[0].id},${props.widget.datasource[0].name},${props.widget.datasource[0].type},${props.widget.datasource[0].host},${props.widget.datasource[0].port},${props.widget.datasource[0].topic},${props.widget.datasource[0].key}`
        }`
      : ""
  );

  const [alarmsForSources, setAlarmsForSources] = useState({});
  const [displayAlarmsPerSource, setDisplayAlarmsPerSource] = useState(
    props.widget?.datasource?.map((ds) => ({
      sourceId: ds.id,
      enabled: props.widget?.displayAlarms || false,
    })) || []
  );

  // Prepare options for dropdown
  const prepareOptions = () => {
    const options = [];

    // Add HTTP sources
    if (httpDatasources?.data) {
      httpDatasources.data.forEach((dataSrc) => {
        options.push({
          value: `${dataSrc.id},${dataSrc.key},${dataSrc.name},${dataSrc.type},${dataSrc.URL},${dataSrc.method}`,
          name: dataSrc.name,
          type: dataSrc.type,
          method: dataSrc.method,
          url: dataSrc.URL,
          id: dataSrc.id,
        });
      });
    }

    // Add MQTT sources
    if (mqttDatasources?.data) {
      mqttDatasources.data.forEach((dataSrc) => {
        options.push({
          value: `${dataSrc.id},${dataSrc.name},${dataSrc.type},${dataSrc.host},${dataSrc.port},${dataSrc.topic},${dataSrc.key}`,
          name: dataSrc.name,
          type: dataSrc.type,
          host: dataSrc.host,
          port: dataSrc.port,
          topic: dataSrc.topic,
          id: dataSrc.id,
        });
      });
    }

    return options;
  };

  const fetchAlarms = async (sourceIds) => {
    if (!sourceIds || !sourceIds.length) {
      setAlarmsForSources({});
      return;
    }
    try {
      const responses = await Promise.all(
        sourceIds.map((id) =>
          axios.get(
            `${config.BACKEND_URL}/logger_sources/alarms/for-source/${id}`,
            { headers }
          )
        )
      );
      const alarmsMap = {};
      responses.forEach((res, index) => {
        const sourceId = sourceIds[index];
        alarmsMap[sourceId] = res.data || [];
      });
      setAlarmsForSources(alarmsMap);
    } catch (error) {
      console.error("Error fetching alarms:", error);
      setAlarmsForSources({});
    }
  };

  const updateWidgetAtPath = (paneArray, path, updateFn) => {
    const newPaneArray = _.cloneDeep(paneArray);
    let current = newPaneArray;
    for (let i = 0; i < path.length - 1; i++) {
      current = current[path[i]].widgetsArray;
    }
    const widgetIndex = path[path.length - 1];
    current[widgetIndex] = updateFn(current[widgetIndex]);
    return newPaneArray;
  };

  useEffect(() => {
    if (props.widget?.datasource && props.widget.datasource.length > 0) {
      const sourceIds = props.widget.datasource
        .map((ds) => ds.id)
        .filter((id) => id);
      if (sourceIds.length > 0) {
        fetchAlarms(sourceIds);
      }
    }
  }, []);

  const widgetSettingHandler = async (event) => {
    if (event) event.preventDefault();

    let data = [];
    const widgetType = props.widget.widget_type;

    if (
      [
        "realtime_chart",
        "equilizer_bar",
        "realtime_table",
        "map_widget",
      ].includes(widgetType)
    ) {
      selectedSources.forEach((selectedValue, index) => {
        if (selectedValue) {
          const split = selectedValue.split(",");
          if (split.length === 6) {
            data.push({
              id: split[0],
              key: split[1],
              name: split[2],
              type: split[3],
              URL: split[4],
              method: split[5],
            });
          } else if (split.length === 7) {
            data.push({
              id: split[0],
              name: split[1],
              type: split[2],
              host: split[3],
              port: split[4],
              topic: split[5],
              key: split[6],
            });
          }
        }
      });
    } else if (selectedSource) {
      const split = selectedSource.split(",");
      if (split.length === 6) {
        data.push({
          id: split[0],
          key: split[1],
          name: split[2],
          type: split[3],
          URL: split[4],
          method: split[5],
        });
      } else if (split.length === 7) {
        data.push({
          id: split[0],
          name: split[1],
          type: split[2],
          host: split[3],
          port: split[4],
          topic: split[5],
          key: split[6],
        });
      }
    }

    const allAlarmsAccessible = [];
    Object.values(alarmsForSources).forEach((sourceAlarms) => {
      if (sourceAlarms && sourceAlarms.length > 0) {
        sourceAlarms.forEach((alarm) => {
          allAlarmsAccessible.push({
            id: alarm.id,
            title: alarm.title,
            color: alarm.color,
            value: alarm.value,
            direction: alarm.direction,
            violated: alarm.violated,
            createdAt: alarm.createdAt,
            updatedAt: alarm.updatedAt,
            sourceId: alarm.sourceId,
            userGroupIDs: alarm.userGroupIDs || [],
          });
        });
      }
    });

    const updatedPaneArray = updateWidgetAtPath(
      props.paneArray,
      props.widgetPath,
      (widget) => {
        const updatedWidget = { ...widget, datasource: data };
        if (data.length > 0) {
          updatedWidget.alarms = allAlarmsAccessible;
          updatedWidget.displayAlarms = displayAlarmsPerSource.some(
            (ds) => ds.enabled
          );
        }
        return updatedWidget;
      }
    );

    props.setPaneArray(updatedPaneArray);
    props.setChangeSourceModal(false);
  };

  const hasAlarmsForSource = (sourceId) => {
    return alarmsForSources[sourceId]?.length > 0;
  };

  if (!props.widget || !props.widget.datasets) {
    return (
      <div className="modern-modal-overlay">
        <div
          className="modern-overlay"
          onClick={() => props.setChangeSourceModal(false)}
        ></div>

        <div
          className="modern-modal-content"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modern-modal-header">
            <button
              className="modern-close-button"
              onClick={() => props.setChangeSourceModal(false)}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>

          <div
            style={{
              textAlign: "center",
              margin: "60px 0",
              fontSize: "18px",
              fontWeight: "500",
              color: "#6b7280",
            }}
          >
            Widget data not available
          </div>
        </div>
      </div>
    );
  }

  const options = prepareOptions();

  // return (
  //   <div className="modalOverlay">
  //     <div className="overlay" onClick={() => props.setChangeSourceModal(false)}></div>
  //     <div className="modal-content" style={{ maxWidth: '600px', width: '90%' }}>
  //       <div className="close-form">
  //         <button className="close-modal btn btn-danger" onClick={() => props.setChangeSourceModal(false)}>
  //           <FontAwesomeIcon icon={faTimes} />
  //         </button>
  //       </div>

  //       {(isHttpPending || isMqttPending) && (
  //         <div className="text-center mt-5 h4">
  //           <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
  //             <div className="spinner-border spinner-border-sm" role="status"></div>
  //             Loading sources... <span style={{ fontSize: '14px', color: '#6c757d' }}>(Timeout: 5s)</span>
  //           </div>
  //         </div>
  //       )}

  //       {(httpError || mqttError) && (
  //         <div className="text-center mt-5 h4" style={{ color: '#dc3545' }}>
  //           Failed to load sources! Showing cached data or empty list.
  //         </div>
  //       )}

  //       {!isHttpPending && !isMqttPending && !httpError && !mqttError && (
  //         <div className="form-settings" style={{ padding: '20px' }}>
  //           <h5 style={{ marginBottom: '20px', color: '#333', fontWeight: '600' }}>
  //             Configure Data Sources
  //           </h5>

  //           <form onSubmit={widgetSettingHandler} className="widget-datasource">
  //             <div>
  //               {["realtime_chart", "equilizer_bar", "realtime_table"].includes(props.widget.widget_type) ? (
  //                 props.widget.datasets.map((src, ind) => {
  //                   const sourceId = selectedSources[ind]?.split(",")[0];
  //                   return (
  //                     <SearchableDropdown
  //                       key={ind}
  //                       options={options}
  //                       value={selectedSources[ind] || ""}
  //                       onChange={(value) => {
  //                         const newSelectedSources = [...selectedSources];
  //                         newSelectedSources[ind] = value;
  //                         setSelectedSources(newSelectedSources);
  //                         const sourceIds = newSelectedSources.map(src => src.split(",")[0]).filter(id => id);
  //                         setDisplayAlarmsPerSource(sourceIds.map(id => ({
  //                           sourceId: id,
  //                           enabled: displayAlarmsPerSource.find(ds => ds.sourceId === id)?.enabled || false,
  //                         })));
  //                         fetchAlarms(sourceIds);
  //                       }}
  //                       placeholder="Select a source"
  //                       label={props.widget.widget_type === "realtime_table" ? src[`label${ind}`] : (src.label || `Source ${ind + 1}`)}
  //                       hasAlarms={sourceId && hasAlarmsForSource(sourceId)}
  //                       alarmEnabled={displayAlarmsPerSource.find(ds => ds.sourceId === sourceId)?.enabled || false}
  //                       onAlarmToggle={(e) => {
  //                         const newDisplayAlarms = [...displayAlarmsPerSource];
  //                         const existingIndex = newDisplayAlarms.findIndex(ds => ds.sourceId === sourceId);
  //                         if (existingIndex >= 0) {
  //                           newDisplayAlarms[existingIndex].enabled = e.target.checked;
  //                         } else {
  //                           newDisplayAlarms.push({ sourceId: sourceId, enabled: e.target.checked });
  //                         }
  //                         setDisplayAlarmsPerSource(newDisplayAlarms);
  //                       }}
  //                     />
  //                   );
  //                 })
  //               ) : (
  //                 <SearchableDropdown
  //                   options={options}
  //                   value={selectedSource}
  //                   onChange={(value) => {
  //                     setSelectedSource(value);
  //                     const sourceId = value.split(",")[0];
  //                     if (sourceId) {
  //                       setDisplayAlarmsPerSource([{
  //                         sourceId,
  //                         enabled: displayAlarmsPerSource.find(ds => ds.sourceId === sourceId)?.enabled || props.widget?.displayAlarms || false
  //                       }]);
  //                       fetchAlarms([sourceId]);
  //                     } else {
  //                       setDisplayAlarmsPerSource([]);
  //                       setAlarmsForSources({});
  //                     }
  //                   }}
  //                   placeholder="Select a source"
  //                   label="Source"
  //                   hasAlarms={selectedSource && hasAlarmsForSource(selectedSource.split(",")[0])}
  //                   alarmEnabled={displayAlarmsPerSource[0]?.enabled || false}
  //                   onAlarmToggle={(e) => {
  //                     const sourceId = selectedSource.split(",")[0];
  //                     const newDisplayAlarms = [{ sourceId, enabled: e.target.checked }];
  //                     setDisplayAlarmsPerSource(newDisplayAlarms);
  //                   }}
  //                 />
  //               )}

  //               <div style={{ marginTop: '25px', paddingTop: '20px', borderTop: '1px solid #e9ecef' }}>
  //                 <button
  //                   className="btn btn-primary"
  //                   type="submit"
  //                   style={{
  //                     padding: '12px 24px',
  //                     fontSize: '14px',
  //                     fontWeight: '600',
  //                     borderRadius: '6px',
  //                     backgroundColor: '#007bff',
  //                     border: 'none',
  //                     color: '#fff',
  //                     cursor: 'pointer',
  //                     transition: 'all 0.2s ease',
  //                     boxShadow: '0 2px 4px rgba(0, 123, 255, 0.2)'
  //                   }}
  //                   onMouseEnter={(e) => {
  //                     e.target.style.backgroundColor = '#0056b3';
  //                     e.target.style.transform = 'translateY(-1px)';
  //                   }}
  //                   onMouseLeave={(e) => {
  //                     e.target.style.backgroundColor = '#007bff';
  //                     e.target.style.transform = 'translateY(0)';
  //                   }}
  //                 >
  //                   Apply Configuration
  //                 </button>
  //               </div>
  //             </div>
  //           </form>
  //         </div>
  //       )}
  //     </div>
  //   </div>
  // );
  return (
    <div className="modern-modal-overlay">
      <div
        className="modern-overlay"
        onClick={() => props.setChangeSourceModal(false)}
      ></div>

      <div
        className="modern-modal-content"
        onClick={(e) => e.stopPropagation()} // Prevent inside clicks from closing modal
        style={{
          maxWidth: "600px",
          height: "500px",
          width: "90%",
          overflowY: "auto",
        }}
      >
        <div className="modern-modal-header">
          <button
            className="modern-close-button"
            onClick={() => props.setChangeSourceModal(false)}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        {(isHttpPending || isMqttPending) && (
          <div className="text-center mt-5 h4">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <div
                className="spinner-border spinner-border-sm"
                role="status"
                style={{ color: "black" }}
              ></div>
              Loading sources...{" "}
              <span style={{ fontSize: "14px", color: "#6c757d" }}>
                (Timeout: 5s)
              </span>
            </div>
          </div>
        )}

        {(httpError || mqttError) && (
          <div className="text-center mt-5 h4" style={{ color: "#dc3545" }}>
            Failed to load sources! Showing cached data or empty list.
          </div>
        )}

        {!isHttpPending && !isMqttPending && !httpError && !mqttError && (
          <div className="form-settings" style={{ padding: "20px" }}>
            <h5
              style={{
                marginBottom: "20px",
                color: "#333",
                fontWeight: "600",
              }}
            >
              Configure Data Sources
            </h5>

            <form onSubmit={widgetSettingHandler} className="widget-datasource">
              <div>
                {[
                  "realtime_chart",
                  "equilizer_bar",
                  "realtime_table",
                  "map_widget",
                ].includes(props.widget.widget_type) ? (
                  props.widget.datasets.map((src, ind) => {
                    const sourceId = selectedSources[ind]?.split(",")[0];
                    return (
                      <SearchableDropdown
                        key={ind}
                        options={options}
                        value={selectedSources[ind] || ""}
                        onChange={(value) => {
                          const newSelectedSources = [...selectedSources];
                          newSelectedSources[ind] = value;
                          setSelectedSources(newSelectedSources);
                          const sourceIds = newSelectedSources
                            .map((src) => src.split(",")[0])
                            .filter((id) => id);
                          setDisplayAlarmsPerSource(
                            sourceIds.map((id) => ({
                              sourceId: id,
                              enabled:
                                displayAlarmsPerSource.find(
                                  (ds) => ds.sourceId === id
                                )?.enabled || false,
                            }))
                          );
                          fetchAlarms(sourceIds);
                        }}
                        placeholder="Select a source"
                        label={
                          props.widget.widget_type === "realtime_table"
                            ? src[`label${ind}`]
                            : src.label || `Source ${ind + 1}`
                        }
                        hasAlarms={sourceId && hasAlarmsForSource(sourceId)}
                        alarmEnabled={
                          displayAlarmsPerSource.find(
                            (ds) => ds.sourceId === sourceId
                          )?.enabled || false
                        }
                        onAlarmToggle={(e) => {
                          const newDisplayAlarms = [...displayAlarmsPerSource];
                          const existingIndex = newDisplayAlarms.findIndex(
                            (ds) => ds.sourceId === sourceId
                          );
                          if (existingIndex >= 0) {
                            newDisplayAlarms[existingIndex].enabled =
                              e.target.checked;
                          } else {
                            newDisplayAlarms.push({
                              sourceId: sourceId,
                              enabled: e.target.checked,
                            });
                          }
                          setDisplayAlarmsPerSource(newDisplayAlarms);
                        }}
                      />
                    );
                  })
                ) : (
                  <SearchableDropdown
                    options={options}
                    value={selectedSource}
                    onChange={(value) => {
                      setSelectedSource(value);
                      const sourceId = value.split(",")[0];
                      if (sourceId) {
                        setDisplayAlarmsPerSource([
                          {
                            sourceId,
                            enabled:
                              displayAlarmsPerSource.find(
                                (ds) => ds.sourceId === sourceId
                              )?.enabled ||
                              props.widget?.displayAlarms ||
                              false,
                          },
                        ]);
                        fetchAlarms([sourceId]);
                      } else {
                        setDisplayAlarmsPerSource([]);
                        setAlarmsForSources({});
                      }
                    }}
                    placeholder="Select a source"
                    label="Source"
                    hasAlarms={
                      selectedSource &&
                      hasAlarmsForSource(selectedSource.split(",")[0])
                    }
                    alarmEnabled={displayAlarmsPerSource[0]?.enabled || false}
                    onAlarmToggle={(e) => {
                      const sourceId = selectedSource.split(",")[0];
                      const newDisplayAlarms = [
                        { sourceId, enabled: e.target.checked },
                      ];
                      setDisplayAlarmsPerSource(newDisplayAlarms);
                    }}
                  />
                )}

                <div
                  style={{
                    marginTop: "25px",
                    paddingTop: "20px",
                    borderTop: "1px solid #e9ecef",
                  }}
                >
                  <button
                    className="btn btn-primary"
                    type="submit"
                    style={{
                      padding: "12px 24px",
                      fontSize: "14px",
                      fontWeight: "600",
                      borderRadius: "6px",
                      backgroundColor: "#007bff",
                      border: "none",
                      color: "#fff",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      boxShadow: "0 2px 4px rgba(0, 123, 255, 0.2)",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#0056b3";
                      e.target.style.transform = "translateY(-1px)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#007bff";
                      e.target.style.transform = "translateY(0)";
                    }}
                  >
                    Apply Configuration
                  </button>
                </div>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

WidgetSettingModal.propTypes = {
  setChangeSourceModal: PropTypes.func.isRequired,
  paneArray: PropTypes.array.isRequired,
  setPaneArray: PropTypes.func.isRequired,
  widgetPath: PropTypes.array.isRequired,
  widget: PropTypes.shape({
    datasets: PropTypes.array,
    widget_type: PropTypes.string,
    datasource: PropTypes.array,
    displayAlarms: PropTypes.bool,
    alarms: PropTypes.array,
  }),
};

export default WidgetSettingModal;
